<template>
  <img class="car-qr-code" :src="dataUrl" alt="QRCode" />
</template>

<script>
import qrcode from 'qrcode';

export default {
  name: 'QrCode',
  props: {
    value: {
      type: String,
      require: true
    },
    correctionLevel: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['low', 'medium', 'quartile', 'high'].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {
      dataUrl: ''
    }
  },
  watch: {
    $props: {
      deep: true,
      immediate: true,
      handler: 'drawQRCode'
    }
  },
  methods: {
    drawQRCode() {
      qrcode.toDataURL(this.value,
        {
          errorCorrectionLevel: this.correctionLevel,
          type: 'image/png',
          quality: 0.3,
          margin: 0
        }
      ).then(data => (this.dataUrl = data));
    }
  }
}
</script>

<style scoped>

</style>
